import { SpecificationFormRule } from './specification-form-rule';

export class CookstoveRule {
  public static rule(): SpecificationFormRule {
    return {
      fields: {
        postalCode: {
          display: false,
          required: false
        },
        address1: {
          display: false,
          required: false
        },
        address2: {
          display: false,
          required: false
        },
        name: {
          display: true,
          required: true,
          headingKey: 'asset-name'
        },
        projectType: {
          display: true,
          required: true
        },
        description: {
          display: true,
          required: false
        },
        map: {
          display: false,
          required: false
        },
        country: {
          display: true,
          required: true
        },
        state: {
          display: true,
          required: true
        },
        city: {
          display: false,
          required: false
        },
        latitude: {
          display: false,
          required: false
        },
        longitude: {
          display: false,
          required: false
        },
        cod: {
          display: false,
          required: false
        },
        tenderProject: {
          display: true,
          required: false
        },
        currency: {
          display: false,
          required: false
        },
        exchangeRate: {
          display: false,
          required: false
        },
        program: {
          display: true,
          required: false
        },
        status: {
          display: false,
          required: false
        }
      },
      keys: {
        header: 'site-location',
        info: 'basic-info',
        location: 'claim-location',
        currency: 'tariff'
      }
    };
  }
}
